import React, { Component } from "react";

import NavLinks from "../NavLinks/NavLinks";
import { linkTypes } from "../../../interfaces/interfaces";
import PowderPile from "../Graphics/PowderPile";

import { footerHighlightColor } from "../../../styles/master";
import styles from "./Footer.module.scss";
import { NavLink } from "react-router-dom";

class Footer extends Component {
  state: {
    showAnimation: boolean;
    animationWidth: number;
    animationHeight: number;
  };

  constructor(props: {}) {
    super(props);
    this.state = {
      showAnimation: false,
      animationHeight: 0,
      animationWidth: 0
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.showAnimation.bind(this));
    window.addEventListener("resize", this.resize.bind(this));
    this.sizeFrame();
  }

  sizeFrame() {
    let animationFrame = document.getElementById(styles.footerGraphic);
    if (animationFrame) {
      this.setState({
        animationWidth: animationFrame!.clientWidth,
        animationHeight: animationFrame!.clientHeight
      });
    }
  }

  resize() {
    this.setState({ showAnimation: false });
    this.sizeFrame();
  }

  showAnimation() {
    let footer = document.getElementById(styles.footerContainer);
    if (
      footer &&
      footer.getBoundingClientRect().bottom - window.innerHeight < 5
    ) {
      this.setState({ showAnimation: true });
    }
  }

  render() {
    return (
      <div id={styles.footerContainer}>
        <NavLink to="/">
          <span id={styles.logo}>PSI</span>
        </NavLink>
        <NavLinks
          displayStyle={linkTypes.footer}
          slideDownAnimation={false}
          activeColor={footerHighlightColor}
        />
        <div id={styles.footerGraphic}>
          {this.state.showAnimation && (
            <PowderPile
              width={this.state.animationWidth}
              height={this.state.animationHeight}
            />
          )}
        </div>
        <div id={styles.siteInfo}>
          <div id={styles.siteBy}>
            <a id={styles.link} href="https://www.ab-websites.com">
              Site By AB Website Development
            </a>
          </div>
          <div id={styles.copyright}>&copy; 2019 Powder Solutions Inc.</div>
        </div>
      </div>
    );
  }
}

export default Footer;
